import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { User } from '../../../models/User';

const updateUserInfo = (user: User) => async (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.updateUserInfoAction(user));
};

export { updateUserInfo };



// WEBPACK FOOTER //
// ./src/redux/modules/user/operations.ts